// ignore-string-externalization
import type { ErrorEvent, SeverityLevel } from '@sentry/types';

export type KnownIssue = {
  id: string;
  description: string;
  resolvedBy: string;
  match: (event: ErrorEvent) => boolean;
  level: SeverityLevel;
};

export const knownIssues: KnownIssue[] = [
  {
    id: 'stylis-stack-overflow',
    description:
      'styled-components stylis CSS serialization overflows the call stack on iOS devices ' +
      'with limited stack depth. Root cause is recursive AST traversal in stylis ' +
      'serialize/stringify — not an infinite loop, just too deep for iOS WebKit.',
    resolvedBy:
      'Upgrade to styled-components v7 (replaces stylis with a non-recursive parser). ' +
      'Remove this entry and the @sentry/types dev dependency when resolved.',
    level: 'warning',
    match(event) {
      const ex = event.exception?.values?.[0];
      if (!/Maximum call stack size exceeded/.test(ex?.value ?? ''))
        return false;
      const frames = ex?.stacktrace?.frames;
      if (!frames || frames.length < 40) return false;
      // Stylis serialize/stringify are adjacent functions in the minified
      // bundle: same line, two distinct columns, two distinct function names.
      // We match this structural pattern rather than relying on minified
      // names which change between builds.
      const top = frames.slice(-20);
      const fns = new Set(top.map(f => f.function).filter(Boolean));
      const lines = new Set(top.map(f => f.lineno).filter(Boolean));
      const cols = new Set(top.map(f => f.colno).filter(Boolean));
      return (
        fns.size >= 2 &&
        fns.size <= 3 &&
        lines.size === 1 &&
        cols.size >= 2 &&
        cols.size <= 3
      );
    },
  },
];
